import { Link } from "react-router-dom"

const ConfirmBloc=(props)=>{
return(
    <>
     <div className=" bg-white radius8 text-center p-40 ">
                <img src="/images/checkGreen.svg" alt="check icon" />
                <h3 className="mt-32">{props?.title} </h3>
               {props?.text && <p className="body text-center mt-16">{props?.text}</p>} 
                <button className="btn twyny-cta-primary w-100 mt-32" 
                onClick={props.clickPrimary}>
                    {props?.btnText}</button>
                <div className="mt-24">
                    <Link to={props?.ctaLink} className="link-primary mt-24">
                {props?.ctatext}
                </Link>
                    </div>
            </div>
    </>
)
}
export default ConfirmBloc